/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { OperationsTaskType } from "./OperationsTaskType";
import {
  OperationsTaskTypeFromJSON,
  OperationsTaskTypeFromJSONTyped,
  OperationsTaskTypeToJSON,
  OperationsTaskTypeToJSONTyped,
} from "./OperationsTaskType";

/**
 *
 * @export
 * @interface ShipmentCarrierEmail
 */
export interface ShipmentCarrierEmail {
  /**
   *
   * @type {string}
   * @memberof ShipmentCarrierEmail
   */
  frontMessageId: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentCarrierEmail
   */
  frontConversationId: string;
  /**
   *
   * @type {OperationsTaskType}
   * @memberof ShipmentCarrierEmail
   */
  operationsTaskType: OperationsTaskType;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentCarrierEmail
   */
  isInbound: boolean;
  /**
   *
   * @type {string}
   * @memberof ShipmentCarrierEmail
   */
  fromHandle?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShipmentCarrierEmail
   */
  fromName?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShipmentCarrierEmail
   */
  subject?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShipmentCarrierEmail
   */
  bodyText?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ShipmentCarrierEmail
   */
  messageCreatedAt: OffsetDateTime;
}

/**
 * Check if a given object implements the ShipmentCarrierEmail interface.
 */
export function instanceOfShipmentCarrierEmail(
  value: object,
): value is ShipmentCarrierEmail {
  if (!("frontMessageId" in value) || value["frontMessageId"] === undefined)
    return false;
  if (
    !("frontConversationId" in value) ||
    value["frontConversationId"] === undefined
  )
    return false;
  if (
    !("operationsTaskType" in value) ||
    value["operationsTaskType"] === undefined
  )
    return false;
  if (!("isInbound" in value) || value["isInbound"] === undefined) return false;
  if (!("messageCreatedAt" in value) || value["messageCreatedAt"] === undefined)
    return false;
  return true;
}

export function ShipmentCarrierEmailFromJSON(json: any): ShipmentCarrierEmail {
  return ShipmentCarrierEmailFromJSONTyped(json, false);
}

export function ShipmentCarrierEmailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentCarrierEmail {
  if (json == null) {
    return json;
  }
  return {
    frontMessageId: json["frontMessageId"],
    frontConversationId: json["frontConversationId"],
    operationsTaskType: OperationsTaskTypeFromJSON(json["operationsTaskType"]),
    isInbound: json["isInbound"],
    fromHandle: json["fromHandle"] == null ? undefined : json["fromHandle"],
    fromName: json["fromName"] == null ? undefined : json["fromName"],
    subject: json["subject"] == null ? undefined : json["subject"],
    bodyText: json["bodyText"] == null ? undefined : json["bodyText"],
    messageCreatedAt: json["messageCreatedAt"],
  };
}

export function ShipmentCarrierEmailToJSON(json: any): ShipmentCarrierEmail {
  return ShipmentCarrierEmailToJSONTyped(json, false);
}

export function ShipmentCarrierEmailToJSONTyped(
  value?: ShipmentCarrierEmail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    frontMessageId: value["frontMessageId"],
    frontConversationId: value["frontConversationId"],
    operationsTaskType: OperationsTaskTypeToJSON(value["operationsTaskType"]),
    isInbound: value["isInbound"],
    fromHandle: value["fromHandle"],
    fromName: value["fromName"],
    subject: value["subject"],
    bodyText: value["bodyText"],
    messageCreatedAt: value["messageCreatedAt"],
  };
}
